import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormApi from '../../api/forms';
import { showError, showMessage } from '../../actions/uiActions';
import LineProgress from '@mui/material/LinearProgress'
import { connect } from 'react-redux';

class EditCustomFormTitle extends Component {
    
    state = {
      documentName: this.props.editForm.documentName,
      notes: this.props.editForm.notes,
      busy: false
    }
  
  submit = async () => {
    if (!this.state.documentName) {
      this.props.showError("Form name is required")
      return;
    } else {
      try {
        this.setState({ busy: true })
        const payload = { 'documentName': this.state.documentName, 'notes': this.state.notes };
        await FormApi.updateForm(this.props.editForm.userId, this.props.editForm.formId, payload)
        this.props.showMessage("Document title and notes successfully updated.");
        this.props.onClose();
      } catch (error) {
        this.setState({ busy: false }, () => this.props.showError(error.response.data.message))
      }
    }
  }

  render() {
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" open={true}
      >
        <DialogTitle id="alert-dialog-title">Rename Form Name</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Use the input fields below to rename the form name and notes.
          </DialogContentText>
          <div className="line-break"></div>
          <div className="form-group nice text-center">
            <input
              disabled={this.state.busy}
              style={{ display: "inline-block", width: "60%" }}
              autoComplete="documentName"
              value={this.state.documentName}
              type="text"
              name="documentName"
              onChange={e => this.setState({ documentName: e.target.value })}
              className="form-control"
              placeholder="Enter new form name" />
          </div>
          <div className="line-break"></div>
          <div className="form-group nice text-center">
            <input
              disabled={this.state.busy}
              style={{ display: "inline-block", width: "60%" }}
              autoComplete="notes"
              value={this.state.notes}
              type="text"
              name="notes"
              onChange={e => this.setState({ notes: e.target.value })}
              className="form-control"
              placeholder="Enter new form notes" />
          </div>
        </DialogContent>
        <DialogActions>
          {!this.state.busy && [<Button variant="outlined" onClick={this.submit} color="primary" autoFocus>
            Save Changes
          </Button>,
            <Button onClick={this.props.onClose} color="primary">
            Cancel
          </Button>]}
          {this.state.busy && <LineProgress variant="indeterminate" />}
        </DialogActions>
      </Dialog>
    )
  }
}
export default connect(null, { showError, showMessage })(EditCustomFormTitle);